import {ChangeDetectionStrategy, Component, Input} from '@angular/core';

@Component({
  selector: 'app-spinner',
  templateUrl: './spinner.component.html',
  styleUrls: ['./spinner.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SpinnerComponent {
  @Input() name = '';
  @Input() overlay = false;
  /** Existing callers retain their positioned mask; embedded loaders opt in. */
  @Input() inline = false;
  @Input() size = '2.25rem';
  @Input() multicolor = false;
}
